import { render } from "./UserType.vue?vue&type=template&id=3599b159&scoped=true&ts=true"
import script from "./UserType.vue?vue&type=script&lang=ts&scoped=true"
export * from "./UserType.vue?vue&type=script&lang=ts&scoped=true"

import "./UserType.vue?vue&type=style&index=0&id=3599b159&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod_electronic-delivery-responsive_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3599b159"]])

export default __exports__